/// <reference path="../../typings/tsd.d.ts" /> 
module Elp.Api {
    export class Process{

        private static getProcess(processId: string): Wars.Domain.Model.Dtos.ProcessDto {
            const processService: Services.ProcessService = angular.element(document.body).injector().get('processService');

            return processService.getCachedProcess(processId);
        }

        public static setField(processId: string, formId: string, formDataId: any, uniqueId: string, value: any) {
            const formDataService:Services.FormDataService=angular.element(document.body).injector().get('formDataService');

            const processDto = this.getProcess(processId);

            formDataService.setFormField(processId, formId, formDataId, uniqueId, value)
                .then(r => {
                    processDto.formJson[formId][formDataId][uniqueId] = value;
                });
        }

        public static addRow(processId: string, formId: string, formDataId: any, uniqueId: string,onlyAllowApiEdits?: boolean):angular.IPromise<string> {
            const $q: angular.IQService = angular.element(document.body).injector().get('$q');

            var d = $q.defer();

            const formDataService: Services.FormDataService =
                angular.element(document.body).injector().get('formDataService');

            var newItem = { id: warsApp.services.UtilityService.generateGuidComb() };
            formDataService.addListRow(processId, formId, formDataId, uniqueId, newItem.id,onlyAllowApiEdits).then(r => {
                const processDto = this.getProcess(processId);

                //if (!processDto.formJson[formId][formDataId][uniqueId]) {
                //    processDto.formJson[formId][formDataId][uniqueId] = [];
                //}

                //processDto.formJson[formId][formDataId][uniqueId].push(newItem); 
                d.resolve(newItem.id);
            });

            return d.promise;
        }

        public static removeRow(processId: string, formId: string, formDataId: any, uniqueId: string,rowId:string) {
            const formDataService: Services.FormDataService =
                angular.element(document.body).injector().get('formDataService');

            formDataService.removeListRow(processId, formId, formDataId, uniqueId, rowId).then(r => {
                const processDto = this.getProcess(processId);;
            });
        }

        public static getField(processId: string, formId: string, formDataId: any, uniqueId: string) {
            const processDto = this.getProcess(processId);

            return processDto.formJson[formId][formDataId][uniqueId];
        }

        public static getEnumeratedRowValue(row:any,uniqueId:any) {
            return row[uniqueId];
        }

        public static setEnumeratedRowValue(processId: string, formId: string, formDataId: any, uniqueId: any, fieldUniqueId: string, row: any, value: any) {
            row[uniqueId] = value;
            const formDataService:Services.FormDataService=angular.element(document.body).injector().get('formDataService');
            formDataService.setListField(processId, formId, formDataId, uniqueId, row.id, fieldUniqueId, value);
            row[fieldUniqueId] = value;

            //formDataService.setListField()
        }

        public static getRowValue(processId: string, formId: string, formDataId: any, uniqueId: string, rowId:string,fieldUniqueId:string) {
            const processDto = this.getProcess(processId);

            return processDto.formJson[formId][formDataId][uniqueId][rowId][fieldUniqueId];

        }

        public static setRowValue(processId: string, formId: string, formDataId: any, uniqueId: string,fieldUniqueId: string,
            rowId: string,value:any,isReadOnly:boolean):angular.IPromise<any> {
            const processDto = this.getProcess(processId);

            const formDataService:Services.FormDataService=angular.element(document.body).injector().get('formDataService');
            return formDataService.setListField(processId, formId, formDataId, uniqueId, rowId, fieldUniqueId, value, isReadOnly);

            //var row=Enumerable.from(processDto.formJson[formId][formDataId][uniqueId]).single(r => (<any>r).id === rowId);

            //row[fieldUniqueId] = value;
        }

        public static loopThruRows(processId: string, formId: string, formDataId: any, uniqueId: string,rowCallback:(row:any)=>any) {
            const processDto = this.getProcess(processId);;
            processDto.formJson[formId][formDataId][uniqueId].forEach(row => {
                //console.log(row);
                rowCallback(row);
            });
        }

        public static removeAllRows(processId: string, formId: string, formDataId: any, uniqueId: string) {
            const processDto = this.getProcess(processId);
            const formDataService: Services.FormDataService =
                angular.element(document.body).injector().get('formDataService');

            let counter = 0;
            processDto.formJson[formId][formDataId][uniqueId].forEach(f => {
                counter++;
                formDataService.removeListRow(processId, formId, formDataId, uniqueId, f.id)
                    .then(r => {
                        counter--;
                        if (counter === 0) {
                            processDto.formJson[formId][formDataId][uniqueId] = [];
                        }
                    });
            });

        }
    }

} 